import { Job } from "screens/Job";
import { withUserServerSideProps } from "lib/serverSideProps/withUser";
import {
  ServerSideContext,
  withServerSideProps,
} from "lib/serverSideProps/withServerSideProps";
import { instance } from "@clearabee/ui-sdk";
import { GetRouteParams } from "lib/routes";
import { withWebLayout } from "lib/hoc/withWebLayout";
import { withHOC } from "lib/hoc/withHOC";

export const getServerSideProps = withServerSideProps(
  [
    withUserServerSideProps,
    async ({ query }: ServerSideContext<GetRouteParams<"Job">>) => {
      const { data: job } = await instance.jobs.getJobByRef(
        encodeURIComponent(query.ref),
      );

      return { props: { job } };
    },
  ],
  { ignoreClient: true },
);

export default withHOC([withWebLayout], Job);
